import {
	ServiceManagementEndpoint,
	ServiceManagementEndpointRoutes
} from './service-management.interface';

export class ServiceManagementEndpointFactory 
{
	public static build(baseUrl: string): ServiceManagementEndpoint 
	{
		return {
			baseUrl: baseUrl,
			routes: this.buildRoutes(baseUrl)
		};
	}
	private static buildRoutes(baseUrl: string): ServiceManagementEndpointRoutes 
	{
		return {
			serviceManagement: {
				toString: () => `${baseUrl}v0/api`,
				getSpendBreakdownData: {
					toString: () => `${baseUrl}v0/service-management/service-history/widget/spend-invoices`
				},
				getRepairCodeData: {
					toString: () => `${baseUrl}v0/service-management/service-history/widget/top-repair-codes`
				},
				getPaymentStatusData: {
					toString: () => `${baseUrl}v0/service-management/service-history/widget/payment-status`
				}
			}
		} as ServiceManagementEndpointRoutes;
	}
}
